// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalV1MedicalBiDefaultResponse {
    static getAttributeTypeMap() {
        return MedicalV1MedicalBiDefaultResponse.attributeTypeMap;
    }
}
MedicalV1MedicalBiDefaultResponse.discriminator = undefined;
MedicalV1MedicalBiDefaultResponse.additionalProperties = false;
MedicalV1MedicalBiDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "MedicalV1MedicalBiDefaultResponseData"
    },
];
//# sourceMappingURL=medicalV1MedicalBiDefaultResponse.js.map